var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "b-overlay",
        { attrs: { show: _vm.buscando, rounded: "sm" } },
        [
          _vm.mostrarInfo
            ? _c(
                "b-row",
                { staticClass: "text-right" },
                [
                  _c(
                    "b-col",
                    [
                      _c(
                        "b-badge",
                        {
                          directives: [
                            {
                              name: "b-tooltip",
                              rawName: "v-b-tooltip.hover",
                              value: _vm.$t(
                                "apeironGwApp.buscadorInstitucionesSnp.mensajes.infoAyuda"
                              ),
                              expression:
                                "$t('apeironGwApp.buscadorInstitucionesSnp.mensajes.infoAyuda')",
                              modifiers: { hover: true },
                            },
                          ],
                          attrs: { pill: "", variant: "primary" },
                        },
                        [_c("b-icon", { attrs: { icon: "question-circle" } })],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.buscadorInstitucionesSnp.mensajes.filtroReniecyt"
                        ),
                        "label-for": "input-reniecyt",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-reniecyt",
                          placeholder: _vm.$t(
                            "apeironGwApp.buscadorInstitucionesSnp.mensajes.filtroReniecyt"
                          ),
                        },
                        model: {
                          value: _vm.filtroReniecyt,
                          callback: function ($$v) {
                            _vm.filtroReniecyt = $$v
                          },
                          expression: "filtroReniecyt",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                [
                  _c(
                    "b-form-group",
                    {
                      staticClass: "mb-2",
                      attrs: {
                        label: _vm.$t(
                          "apeironGwApp.buscadorInstitucionesSnp.mensajes.filtroNombreInstitucion"
                        ),
                        "label-for": "input-nombre-institucion",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "input-nombre-institucion",
                          placeholder: _vm.$t(
                            "apeironGwApp.buscadorInstitucionesSnp.mensajes.filtroNombreInstitucion"
                          ),
                        },
                        model: {
                          value: _vm.filtroNombreInstitucion,
                          callback: function ($$v) {
                            _vm.filtroNombreInstitucion = $$v
                          },
                          expression: "filtroNombreInstitucion",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "pt-4" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-3",
                      attrs: {
                        disabled:
                          _vm.buscando ||
                          (!_vm.filtroReniecyt && !_vm.filtroNombreInstitucion),
                        variant: "primary",
                      },
                      on: { click: _vm.buscarDesdePrimerPagina },
                    },
                    [
                      !_vm.buscando
                        ? _c(
                            "div",
                            [
                              _c("b-icon", { attrs: { icon: "search" } }),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.$t("global.process.search.action"))
                                ),
                              ]),
                            ],
                            1
                          )
                        : _c("span", [
                            _c("em", [
                              _vm._v(
                                _vm._s(
                                  _vm.$t("global.process.search.searching")
                                )
                              ),
                            ]),
                          ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.instituciones.length,
                  expression: "instituciones.length",
                },
              ],
            },
            [
              _c("b-col", [
                _c("h5", {
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t(
                        "apeironGwApp.buscadorInstitucionesSnp.mensajes.instituciones"
                      )
                    ),
                  },
                }),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "py-2 area-responsive area-responsive-listado" },
                _vm._l(_vm.instituciones, function (institucion) {
                  return _c(
                    "b-row",
                    { key: institucion.id },
                    [
                      _c(
                        "b-col",
                        [
                          _c("buscador-institucion-snp", {
                            attrs: {
                              institucion: institucion,
                              seleccionarSoloInstitucion:
                                _vm.seleccionarSoloInstitucion,
                              ocultarSedes: _vm.ocultarSedes,
                            },
                            on: { selected: _vm.emitirSeleccion },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.instituciones.length > 0
            ? _c(
                "b-row",
                { staticClass: "mt-4" },
                [
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { attrs: { md: "4" } },
                            [
                              _c("b-form-select", {
                                attrs: {
                                  size: "sm",
                                  id: "per-page-select",
                                  options: _vm.pageOptions,
                                },
                                on: { change: _vm.buscarDesdePrimerPagina },
                                model: {
                                  value: _vm.perPageCards,
                                  callback: function ($$v) {
                                    _vm.perPageCards = $$v
                                  },
                                  expression: "perPageCards",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "pie-tabla mt-1",
                              attrs: { md: "8" },
                            },
                            [
                              _c("label", [
                                _c("span", {
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "apeironGwApp.buscadorInstitucionesSnp.mensajes.registrosPorPagina"
                                      )
                                    ),
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    { attrs: { md: "4" } },
                    [
                      _c("b-pagination", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.totalRowsCards / _vm.perPageCards > 1,
                            expression: "totalRowsCards / perPageCards > 1",
                          },
                        ],
                        attrs: {
                          size: "sm",
                          "total-rows": _vm.totalRowsCards,
                          "per-page": _vm.perPageCards,
                          align: "fill",
                          pills: "",
                        },
                        on: { change: _vm.cambiarPagina },
                        model: {
                          value: _vm.currentPageCards,
                          callback: function ($$v) {
                            _vm.currentPageCards = $$v
                          },
                          expression: "currentPageCards",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      staticClass: "text-right pie-tabla mt-1",
                      attrs: { md: "4" },
                    },
                    [
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.totalRowsCards) },
                      }),
                      _c("span", {
                        staticClass: "ml-1",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t(
                              "apeironGwApp.buscadorInstitucionesSnp.mensajes.totalDeRegistros"
                            )
                          ),
                        },
                      }),
                    ]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }